export default __webpack_public_path__ + "static/media/SubImage2.a10f7537.JPG";